import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

const Header = () => {
  const {
    setUserId,
    setToken,
    setSessionId,
    setAccountId,
    setPrefix,
    setName,
    setEmail,
  } = useAuth();
  const navigate = useNavigate();
  const isTopUp = localStorage.getItem("isTopUp");
  const InActive = localStorage.getItem("InActive");

  const handleLogout = () => {
    if (window.confirm("Are you sure to Logout.")) {
      localStorage.setItem("userAuth", JSON.stringify(""));
      localStorage.setItem("isTopUp", "");
      localStorage.setItem("InActive", "");
      setUserId(null);
      setToken(null);
      setSessionId(null);
      setAccountId(null);
      setPrefix(null);
      setName(null);
      setEmail(null);

      navigate("/home");
    }
  };

  return (
    <>
      <header className="site_header header_pepecoin">
        <div className="nav_wrapper">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-3 col-9 d-flex align-items-center header-logo-col">
                <div className="site_logo mt-3">
                  <Link className="site_link" to="/dashboard">
                    <img
                      loading="lazy"
                      src="siteadmin/images/logo2.png"
                      alt="Tether Mine"
                    />
                    <img
                      loading="lazy"
                      src="/assets/images/site_logo/dark-logo.png"
                      alt="Tether Mine"
                    />
                  </Link>
                </div>
                <Link to="/dashboard">
                  <span
                    className="text-light mx-2"
                    style={{ fontSize: "20px" }}
                  >
                    Tethermine.io
                  </span>
                </Link>
              </div>

              <div className="col-lg-9 col-3 d-flex align-items-center justify-content-end  header-menu-col">
                <nav className="main_menu navbar navbar-expand-lg">
                  <div
                    className="main_menu_inner collapse navbar-collapse justify-content-center"
                    id="main_menu_dropdown"
                  >
                    <ul className="main_menu_list control-cus-font unordered_list text-uppercase">
                      <li className="dropdown cus-mobile-view-only">
                        <Link
                          className="nav-link"
                          to="/dashboard"
                          role="button"
                          aria-expanded="false"
                        >
                          <span
                            className="nav_link_label"
                            data-text="Dashboard"
                          >
                            Dashboard
                          </span>
                        </Link>
                      </li>

                      <li className="dropdown">
                        <Link
                          className="nav-link"
                          to="/investment"
                          role="button"
                          aria-expanded="false"
                        >
                          <span
                            className="nav_link_label"
                            data-text="Stake Report"
                          >
                            Stake Report
                          </span>
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link
                          className="nav-link"
                          to="/ledger"
                          role="button"
                          aria-expanded="false"
                        >
                          <span className="nav_link_label" data-text="Ledger">
                            Ledger
                          </span>
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link
                          className="nav-link"
                          to="/withdrawal"
                          role="button"
                          aria-expanded="false"
                        >
                          <span
                            className="nav_link_label"
                            data-text="Withdrawal"
                          >
                            Withdrawal
                          </span>
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link
                          className="nav-link"
                          to="/referral"
                          role="button"
                          aria-expanded="false"
                        >
                          <span className="nav_link_label" data-text="Referral">
                            Referral
                          </span>
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link
                          to="/direct-team"
                          className="nav-link"
                          role="button"
                          aria-expanded="false"
                        >
                          <span
                            className="nav_link_label"
                            data-text="Direct Team"
                          >
                            Direct Team
                          </span>
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link
                          to="/total-team"
                          className="nav-link"
                          role="button"
                          aria-expanded="false"
                        >
                          <span
                            className="nav_link_label"
                            data-text="Total Team"
                          >
                            Total Team
                          </span>
                        </Link>
                      </li>
                      <li className="dropdown">
                        <a
                          href="https://docs.google.com/gview?url=https://tethermine.io/files/intro.pdf&embedded=true"
                          className="nav-link"
                        >
                          <span
                            className="nav_link_label"
                            data-text="White paper"
                          >
                            White paper
                          </span>
                        </a>
                      </li>
                      {/* <li className="dropdown">
                        <Link
                          to="/contract"
                          className="nav-link"
                          role="button"
                          aria-expanded="false"
                        >
                          <span className="nav_link_label" data-text="View Contract">
                            View Contract
                          </span>
                        </Link>
                      </li> */}
                      <li className="dropdown">
                        <Link to={"/profile"}>
                          <div
                            style={{
                              background: "#000000",
                              borderRadius: "8px",
                            }}
                          >
                            <div style={{ position: "relative" }}>
                              <img
                                width={30}
                                alt="avatar"
                                className="img-fluid b-r-10"
                                src="siteadmin/images/woman.png"
                              />
                              <span
                                className={
                                  "position-absolute top-0 end-0 p-1 border border-light rounded-circle" +
                                  (isTopUp == "true" && InActive != "true"
                                    ? " bg-success"
                                    : " bg-danger")
                                }
                              ></span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li
                        className="dropdown fa-div-sign-out"
                        style={{ marginLeft: "-20px" }}
                      >
                        <Link
                          to={"#"}
                          onClick={handleLogout}
                          className="nav-link mx-2"
                          id="login_submenu"
                          role="button"
                        >
                          <span
                            className="nav_link_labels"
                            style={{ color: "#fff" }}
                            data-text=""
                          >
                            <i className="fa fa-sign-out"></i>
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
                <ul className="btns_group unordered_list p-0 justify-content-end">
                  <li className="d-lg-none">
                    <button
                      className="mobile_menu_btn text-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#main_menu_dropdown"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <i className="fa fa-bars"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
